<template>
    <div class="talentRecruitment">
        <div class="banner">
            <img class="banner"
                 src="@/assets/images/15575639623563564322.png">
        </div>
        <div class="Crumbs">
            <breadcrumb />
        </div>
        <div class="bgcolor">
            <div class="main">
                <el-form :model="ruleForm"
                         :rules="rules"
                         ref="ruleForm"
                         label-width="0px"
                         class="demo-ruleForm">
                    <el-form-item class="search"
                                  label=""
                                  prop="region">
                        <span>工作地点</span><span class="bor">|</span>
                        <el-cascader placeholder="试试搜索"
                                     v-model="pagination.region"
                                     :props="props"
                                     :options="cityOptions"
                                     clearable
                                     @change="changeregion"
                                     filterable></el-cascader>
                    </el-form-item>
                    <el-form-item class="search"
                                  label=""
                                  prop="positionType">
                        <span>职位类型</span><span class="bor">|</span>
                        <el-select v-model="ruleForm.data.positionType"
                                   placeholder="请选择">
                            <el-option v-for="item in options"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="entry"
                                  label=""
                                  prop="name">
                        <el-input maxlength="20"
                                  placeholder="请输入关键词"
                                  v-model="ruleForm.data.name">
                        </el-input>
                        <el-button type="success"
                                   @click="querySubmitForm()">职位搜索</el-button>

                    </el-form-item>
                </el-form>
            </div>
            <div class="Chart">
                <div class="details"
                     v-for="(item ,index) in tableData"
                     :key="index"
                     @click="changeRoute(item)">
                    <div class="detailsmain">
                        <h4>{{item.name}}</h4>
                        <p>发布时间：<span>{{item.updated|formatDate}}</span></p>
                        <hr>
                        <div>
                            <!-- <div class="children">
                                <p>{{item.positionTypeName}}</p>
                                <p>岗位类型</p>
                            </div>
                            <div class="children">
                                <p>{{item.jobCount==''?"若干":item.jobCount}}</p>
                                <p>在招人数</p>
                            </div> -->
                            <div class="children">
                                <p>{{item.educationName}}</p>
                                <p>学历要求</p>
                            </div>
                            <div class="children">
                                <p>{{item.workYearName}}</p>
                                <p>工作年限</p>
                            </div>
                            <div class="children">
                                <p>{{item.cityName}}</p>
                                <p>工作地点</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="tableDatashow"
                     class="imgmain">
                    <img src="@/assets/images/kongjiemian.png">
                    <!-- <p>没有查到任何信息</p> -->
                </div>
            </div>

            <div class="block"
                 v-show="!tableDatashow">
                <el-pagination background=""
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page.sync="ruleForm.pageIndex"
                               :page-sizes="[6, 15, 30]"
                               :page-size="ruleForm.pageSize"
                               layout="total,sizes,prev, pager, next, jumper"
                               :total="ruleForm.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { queryjobposition, queryprovinceandcity } from "@/api/jobPosition";
import { findbytype } from "@/api/sysDict";
import breadcrumb from "@/components/breadcrumb";
import { debuglog } from "util";
import router from "@/router";
export default {
    components: {
        breadcrumb
    },
    data() {
        return {
            ruleForm: {
                data: {
                    city: "",
                    name: "",
                    province: "",
                    categoryId: "",
                    positionType: "",
                    type: "",
                    array: []
                },
                pageIndex: 1,
                pageSize: 6
            },
            // sumdata: {
            //     data: {},
            //     pageIndex: 1,
            //     pageSize: 6
            // },
            //总条数
            total: 0,
            pagination: {
                region: []
            },
            props: {
                value: "code",
                label: "name",
                children: "child"
            },
            tableDatashow: false,
            tableData: [],
            options: [],
            cityOptions: [],
            rules: {
                positionType: []
            }
        };
    },
    created() {
        if (sessionStorage.getItem("citycode")) {
            this.pagination.region = JSON.parse(
                sessionStorage.getItem("citycode")
            );
        }
        if (sessionStorage.getItem("positionType")) {
            this.ruleForm.data.positionType = JSON.parse(
                sessionStorage.getItem("positionType")
            );
        }
        let searchRuleForm = sessionStorage.getItem("ruleForm");
        if (searchRuleForm) {
            this.ruleForm.data = JSON.parse(searchRuleForm).data;
            this.pagination.region = JSON.parse(searchRuleForm).array;
        }
        if (this.$route.query.search) {
            this.ruleForm.data.name = this.$route.query.search;
        }
        if (sessionStorage.getItem("ationcode")) {
            this.pagination.region = JSON.parse(
                sessionStorage.getItem("ationcode")
            );
        }
        let pagenum = parseInt(sessionStorage.getItem("pageindex"));
        this.ruleForm.pageIndex = pagenum;
        if (sessionStorage.getItem("pagesize")) {
            this.ruleForm.pageSize = parseInt(
                sessionStorage.getItem("pagesize")
            );
        } else {
            this.ruleForm.pageSize = 6;
        }
        this.getInit();
    },
    mounted() {
        this.getInitPositionType();
        this.getInitCityType();
    },
    methods: {
        changeregion() {
            sessionStorage.removeItem("ationcode");
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.ruleForm.pageSize = val;
            sessionStorage.setItem("pageindex", 1);
            sessionStorage.setItem("pagesize", val);
            this.ruleForm.pageIndex = 1;
            this.getInit();
        },

        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.ruleForm.pageIndex = val;
            sessionStorage.setItem("pageindex", val);
            this.getInit();
        },
        //职位类型
        getInitPositionType() {
            findbytype("position_type").then(res => {
                this.options = res.data;
            });
        },
        //职位类型
        getInitCityType() {
            queryprovinceandcity(-1).then(res => {
                this.cityOptions = res.data;
            });
        },
        getInit() {
            if (
                this.pagination.region !== null &&
                this.pagination.region !== undefined
            ) {
                this.ruleForm.data.province = this.pagination.region[0];
                this.ruleForm.data.city = this.pagination.region[1];
            } else {
                this.ruleForm.data.province = "";
                this.ruleForm.data.city = "";
            }
            //this.ruleForm.categoryId = this.$route.query.id;
            this.ruleForm.data.type = "1";
            // this.sumdata.data = this.ruleForm;
            queryjobposition(this.ruleForm).then(res => {
                if (res.status === 2000) {
                    this.tableData = res.data.rows;
                    this.ruleForm.total = res.data.total;
                    // this.sumdata.pageIndex = res.data.page;
                    console.log(this.tableData == undefined);
                    if (this.tableData == undefined) {
                        this.tableDatashow = true;
                    } else {
                        this.tableDatashow = false;
                    }
                }
            });
        },
        querySubmitForm() {
            this.ruleForm.array = this.pagination.region;
            //ruleForm 放入 seesion
            sessionStorage.setItem("ruleForm", JSON.stringify(this.ruleForm));
            this.ruleForm.pageIndex = 1;
            sessionStorage.setItem("pageindex", 1);
            this.topath();
            this.getInit();
        },
        topath() {
            this.$router.push({
                path: this.$route.path,
                query: {
                    id: this.$route.query.id,
                    search: this.ruleForm.data.name
                }
            });
        },
        changeRoute(item) {
            let routeUrl = router.resolve({
                path: "/Jobdetails",
                query: {
                    id: this.$route.query.id,
                    contentid: item.id
                }
            });
            window.open(routeUrl.href, "_blank");
        }
    },
    destroyed() {
        sessionStorage.removeItem("ruleForm");
    }
};
</script>
<style scoped lang="scss">
.talentRecruitment {
    .banner {
        width: 100%;
    }
    .bgcolor {
        position: relative;
        padding-top: 30px;
        padding-bottom: 40px;
        width: 100%;
        background-color: #f5f6f7;
        .main {
            width: 1200px;
            margin: 0 auto;
            .search:nth-child(2) {
                margin-left: 40px;
            }
            .search {
                float: left;
                width: 260px;
                height: 50px;
                background-color: #fff;
                .bor {
                    color: #ddd;
                }
                span {
                    font-size: 15px;
                    line-height: 50px;
                    color: #666;
                    margin-left: 26px;
                }
                .el-cascader,
                .el-select {
                    margin-left: 10px;
                    width: 120px;
                    // border: none;
                    // .el-input {
                    //     .el-input__inner {
                    //         border: none !important;
                    //     }
                    // }
                    /deep/ .el-input--suffix .el-input__inner {
                        border-radius: 0;
                        border: none;
                    }
                }
            }
            .entry {
                width: 600px;
                float: right;
                height: 50px;
                margin-bottom: 30px;
                background-color: #fff;
                /deep/ .el-input {
                    width: 500px;
                    height: 50px;
                    border: none;
                    .el-input__inner {
                        height: 50px;
                        border: none;
                    }
                }
                .el-button {
                    height: 50px;
                    font-size: 15px;
                    border-radius: 0;
                    background-color: #fabe00;
                    border: none;
                    color: #fff !important;
                }
            }
        }
        .Chart {
            clear: both;
            width: 1200px;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            .imgmain {
                // width: 400px;
                // margin: 10px auto;
                img {
                    width: 100%;
                }
                p {
                    font-size: 14px;
                    text-align: center;
                    color: #888;
                }
            }
            .details:hover {
                // box-shadow: #ddd 1px 1px 2px 1px;
            }
            .details {
                position: relative;
                cursor: pointer;
                margin: 15px 10px;
                width: 380px;
                height: 197px;
                background-color: #fff;
                .detailsmain {
                    margin: 20px;
                    h4 {
                        font-size: 18px;
                    }
                    h4:hover {
                        color: #fabe00;
                    }
                    p {
                        margin: 19px 0;
                        // margin-left: 20px;
                        font-size: 15px;
                        color: #666666;
                    }
                    hr {
                        border: 1px #e7e7e7 dashed;
                        margin-top: 29px;
                    }
                    .children {
                        margin-top: 18px;
                        float: left;
                        height: 49px;
                        width: 98px;
                        p {
                            margin: 9px 0;
                            text-align: center;
                        }
                        p:nth-child(1) {
                            color: #fabe00;
                            font-weight: 600;
                            font-size: 14px;
                        }
                        p:nth-child(2) {
                            font-size: 13px;
                        }
                    }
                    .children:nth-child(2) {
                        width: 138px;
                    }
                    .children:nth-child(-n + 2) {
                        border-right: 1px #ddd solid;
                    }
                }
            }
        }
        .block {
            margin-top: 20px;
            .el-pagination {
                text-align: center;
                margin-top: 40px;
            }
            /deep/ .el-pagination.is-background .el-pager li {
                border-radius: 15px;
            }
            /deep/ .el-pagination.is-background .btn-prev,
            /deep/ .el-pagination.is-background .btn-next {
                border-radius: 15px;
            }
        }
    }
}
</style>
